export default "__VITE_ASSET__Pn0zufvc__"